import { UI_PREFERENCE_FIELDS } from "@/lib/constants/preferences-client";
import { UIPreferences, UserSettingsItem } from "@/lib/types/user/settings";

/**
 * Extract UI preferences from the metaData field
 * This is a pure function that can be used on both client and server
 */
export function extractUIPreferences(settings: UserSettingsItem): UIPreferences {
  // Guard against null or undefined settings
  if (!settings) return {};

  try {
    // If preferences is not an object or is null/undefined, return empty object  
    const metaData = (settings as any).preferences || {};
    if (typeof metaData !== 'object') return {};

    const uiPreferences: UIPreferences = {};

    // Extract only UI-specific fields from metaData
    for (const field of UI_PREFERENCE_FIELDS) {
      if (metaData[field] !== undefined) {
        uiPreferences[field] = metaData[field];
      }
    }

    return uiPreferences;
  } catch (error) {
    console.error('Error extracting UI preferences:', error);
    return {};
  }
}
